module.exports = __webpack_public_path__ + "banquet/components/Footer/images/banquet_gray.d397a98dad5b5dbea64db4ae8b10a6a5.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Footer/images/banquet_gray.svg
// module id = 1663
// module chunks = 1